document.addEventListener('DOMContentLoaded', function () {
  const TARGET_PRODUCT_IDS = ['10722628174161', '10748509126993', '10748526887249'];

  const pickers = Array.from(document.querySelectorAll('.kqv')).filter((picker) =>
    TARGET_PRODUCT_IDS.includes(String(picker.dataset.productId))
  );

  if (!pickers.length) return;

  pickers.forEach((picker) => {
    const formId = picker.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : picker.closest('form');

    if (!form) return;

    const variantInput = form.querySelector('.product-variant-id');
    const submitBtn = form.querySelector('[name="add"]');
    const atcLabel = form.querySelector('.atc-label');
    const atcCompare = form.querySelector('.qty-test-atc__compare');
    const atcDiscount = form.querySelector('.qty-test-atc__discount');

    const cards = picker.querySelectorAll('[data-kqv-card]');

    const addToCartLabel = picker.dataset.labelAddToCart || 'Add to cart';
    const soldOutLabel = picker.dataset.labelSoldOut || 'Sold out';

    const updateUI = (card) => {
      if (!card || !variantInput) return;

      const variantId = card.dataset.variantId;
      const priceFormatted = card.dataset.priceFormatted || '';
      const compareAtPrice = Number(card.dataset.compareAtPrice || 0);
      const compareAtPriceFormatted = card.dataset.compareAtPriceFormatted || '';
      const discount = Number(card.dataset.discount || 0);
      const isAvailable = card.dataset.available === 'true';

      cards.forEach((item) => {
        item.classList.remove('is-selected');
        const radio = item.querySelector('input[type="radio"]');
        if (radio) radio.checked = false;
      });

      card.classList.add('is-selected');

      const currentRadio = card.querySelector('input[type="radio"]');
      if (currentRadio) currentRadio.checked = true;

      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (submitBtn) {
        submitBtn.disabled = !isAvailable;
      }

      if (atcLabel) {
        if (isAvailable) {
          atcLabel.innerHTML = `
            <span class="qty-test-atc__main">
              ${addToCartLabel} · <span class="qty-test-atc__price">${priceFormatted}</span>
            </span>
            <span class="qty-test-atc__compare"${compareAtPrice > 0 && compareAtPriceFormatted ? '' : ' hidden'}>
              ${compareAtPrice > 0 && compareAtPriceFormatted ? compareAtPriceFormatted : ''}
            </span>
          `;
        } else {
          atcLabel.textContent = soldOutLabel;
        }
      }

      if (atcCompare) {
        if (isAvailable && compareAtPrice > 0 && compareAtPriceFormatted) {
          atcCompare.textContent = compareAtPriceFormatted;
          atcCompare.hidden = false;
        } else {
          atcCompare.textContent = '';
          atcCompare.hidden = true;
        }
      }

      if (atcDiscount) {
        if (isAvailable && compareAtPrice > 0 && discount > 0) {
          atcDiscount.textContent = `-${discount}%`;
          atcDiscount.hidden = false;
        } else {
          atcDiscount.textContent = '';
          atcDiscount.hidden = true;
        }
      }
    };

    cards.forEach((card) => {
      card.addEventListener('click', function () {
        const radio = card.querySelector('input[type="radio"]');
        if (radio && radio.disabled) return;
        updateUI(card);
      });
    });

    const selectedCard =
      picker.querySelector('.kqv__card.is-selected') || picker.querySelector('.kqv__card');

    if (selectedCard) {
      updateUI(selectedCard);
    }
  });
});